import script from "./PedidosCompletadosView.vue?vue&type=script&setup=true&lang=ts"
export * from "./PedidosCompletadosView.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__